const overrides = {
  MuiIcon: {
    root: {
      fontFamily: 'Material Icons Outlined',
      display: 'inline-flex',
    },
  },
  MuiIconButton: {
    root: {
      padding: 8,
    },
  },
  MuiButton: {
    contained: {
      boxShadow: 'none',
      '&:hover, &:active': {
        boxShadow: 'none',
      },
    },
  },
  MuiSnackbarContent: {
    root: {
      color: 'inherit',
    },
  },
};

export default overrides;
